import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import PersonalInfo from '../FormComponents/PersonalInfo/PersonalInfo';
import ContactInfo from '../FormComponents/ContactInfo/ContactInfo';
import EmailPasswordForm from '../FormComponents/EmailPasswordForm/EmailPasswordForm';
import FormSection from '../FormComponents/FormSection';
import useSocCardStatus from '../../hooks/useSocCardStatus';
import PassportIdInfoWrapper from '../FormComponents/PassportIdInfoWrapper';

import UserInfoIcon from '../../img/formSectionIcons/userInfo.svg';
import PassportInfoIcon from '../../img/formSectionIcons/passportInfo.svg';
import ContactInfoIcon from '../../img/formSectionIcons/contactInfo.svg';
import useStyles from './makeStyles';

const UserFormContent = ({
  initialData,
  formProps,
  hasLanguageSensitiveNames,
  hasEmailPassword,
  passportIdInfoComponent,
  hasAddressInputsLanguageSensitiveNames,
}) => {
  const classes = useStyles();

  const { setValue } = formProps;
  const [socCardEnabled, citizenshipUpdate] = useSocCardStatus(setValue);

  return (
    <>
      <FormSection title="personalInfo.header" icon={UserInfoIcon}>
        <PersonalInfo
          initialData={initialData}
          formProps={formProps}
          hasLanguageSensitiveNames={hasLanguageSensitiveNames}
          showEngName
        />
      </FormSection>
      <FormSection title="passportIdInfo.header" icon={PassportInfoIcon}>
        <PassportIdInfoWrapper
          initialData={initialData}
          onCitizenshipChange={citizenshipUpdate}
          socCardEnabled={socCardEnabled}
          formProps={formProps}
        >
          {passportIdInfoComponent}
        </PassportIdInfoWrapper>
      </FormSection>
      <FormSection title="contactInfo.header" icon={ContactInfoIcon}>
        <ContactInfo
          initialData={initialData}
          formProps={formProps}
          showEngAddress
          hasPhone
          hasLanguageSensitiveNames={hasLanguageSensitiveNames}
          hasAddressInputsLanguageSensitiveNames={hasAddressInputsLanguageSensitiveNames}
        />
        {hasEmailPassword && (
          <Box className={classes.emailPasswordFormBox}>
            <EmailPasswordForm
              initialData={initialData}
              formProps={formProps}
              showPasswordFields={false}
            />
          </Box>
        )}
      </FormSection>
    </>
  );
};

UserFormContent.propTypes = {
  initialData: PropTypes.shape({}).isRequired,
  formProps: PropTypes.shape({
    register: PropTypes.func,
    setValue: PropTypes.func,
    getValues: PropTypes.func,
    errors: PropTypes.shape({}),
    triggerValidation: PropTypes.func,
    clearError: PropTypes.func,
  }).isRequired,
  hasLanguageSensitiveNames: PropTypes.bool,
  hasEmailPassword: PropTypes.bool,
  hasAddressInputsLanguageSensitiveNames: PropTypes.bool,
  passportIdInfoComponent: PropTypes.element,
};

UserFormContent.defaultProps = {
  hasLanguageSensitiveNames: false,
  hasEmailPassword: false,
  passportIdInfoComponent: undefined,
  hasAddressInputsLanguageSensitiveNames: false,
};

export default UserFormContent;
